import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  titleYear: {
    width: 'fit-content',
    height: 30,
    backgroundColor: theme.palette.type === 'dark' ? '#ededed22' : '#ededed',
    padding: '4px 7px 5px',
    borderRadius: 2,
    marginRight: 8,
    fontWeight: 500,
  },

  noToBeFinalizedItemText: {
    color: '#6f6f6f',
    fontSize: 15,
  },

  recentPriceTable: {
    borderRadius: 6,
    border: theme.palette.type === 'dark' ? 'solid 1px #e0e0e022' : 'solid 1px #e0e0e0',
    width: 'auto',
    marginTop: 5,
    marginBottom: 24,
  },

  recentPriceTableHead: {
    width: 120,
    height: 30,
    backgroundColor: theme.palette.type === 'dark' ? '#f6f6f622' : '#f6f6f6',
    verticalAlign: 'middle',
  },
  coinUnitPriceContainer: {
    display: 'grid',
    gridTemplateColumns: '.5fr 1fr 10fr',
    marginBottom: '20px',
  },
  coinUnitPriceValue: {
    marginRight: '10px',
    justifySelf: 'end',
  },
  'coinUnitPriceContainer > div': {
    marginRight: '5px',
  },
}));

export default useStyles;
